<template>
  <!-- 医美11-12新激励排行榜 -->
  <div class="ranking">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
      <div v-for="(v, k) in jobTabs" :key="k">
        <div v-if="jobTabs.length > 1 ? currentJobTabIndex == k  : currentJobTab == 3">
          <!-- banner -->
          <img class="banner" :src="`${v.url}20260305/${v.bannerImg}.png`" alt="banner">
          <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule"> 活动规则 </span>
          <!-- 奖品 -->
          <div class="reward-box">
            <div v-if="currentJobTab == '3'">
              <div class="bear-palm">
                <p>获奖奖品</p>
                <div class="reward-bot">
                  <span>激励对象：</span>
                  <p>生美客户经理</p>
                </div>
                <div class="reward-bot">
                  <span>激励条件&奖励内容：</span>
                </div>
                <div class="reward-content">
                  1.非0消费累积人数满35奖励<span>5000美美币</span>，满30奖励<span>4000美美币</span>，满24奖励<span>3000美美币</span>，满18奖励<span>1800美美币</span>，满12奖励<span>1000美美币</span>，满8奖励<span>600美美币</span>
                </div>
                <div class="reward-content">
                  2.非0消费人数中如是当年首次消费新客，额外每人奖励<span>100美美币</span>
                </div>
                <div class="prizeWrapper">
                  <div>
                    <img src="https://staticwecom.beautyfarm.com.cn/20260305/cash.png" alt="">
                  </div>
                </div>
                <div class="reward-tips">
                  活动结束后，将会依据客户经理实际销售数据，导入对应数量的美美币
                </div>
              </div>
            </div>
            <div v-if="currentJobTab == '1'">
              <div class="bear-palm">
                <p>获奖奖品</p>
                <div class="reward-bot">
                  <span>激励对象：</span>
                  <p>美田生美直营区域经理</p>
                </div>
                <div class="reward-bot">
                  <p>激励条件：每组双美非0消费新客人数100%达标后进行PK，排名前三名区域经理获奖</p>
                </div>
                <div class="prizeWrapper">
                  <div class="prizeRank">
                    <div>第1名：CC BOOM超能提-面部</div>
                    <div>第2名：CC BOOM超能提-V脸</div>
                    <div>第3名：CC BOOM超能提-V脸</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentJobTab == '2'">
              <div class="bear-palm">
                <p>获奖奖品</p>
                <div class="reward-bot">
                  <span>激励对象：</span>
                  <p>美田生美直营门店主任</p>
                </div>
                <div class="reward-bot">
                  <p>激励条件：每组双美非0消费新客人数100%达标后进行PK，排名前三名主任获奖</p>
                </div>
                <div class="prizeWrapper">
                  <div class="prizeRank" v-if="currentGroupTab== '第一组' || currentGroupTab== '第二组'">
                    <div>前3名获得：CC BOOM超能提-面部</div>
                  </div>
                  <div class="prizeRank" v-else>
                    <div>前3名获得：CC BOOM超能提-V脸</div>
                  </div>
                </div>
              </div>
            </div>
            <p class="update-time">数据更新时间 {{ updateTime }}</p>
          </div>

          <div class="bg-color"></div>
        </div>
      </div>
      <div class="ranking-box">
        <div class="tabs-box" v-if="jobTabs.length > 1">
          <div class="job-tabs">
            <div>
              <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.tabType }" @click="onJobTab(it)">
                {{ it.tabName }}
              </div>
            </div>
            <div :class="['group-tabs', jobTabs[currentJobTabIndex]?.groupTabs?.length > 0 ? 'mb-50' : '']">
              <div class="group-tab-item" :class="{ on: currentGroupTab == j }" v-for="(j, n) in jobTabs[currentJobTabIndex]?.groupTabs" :key="n" @click="onGroupTab(j)">
                {{ j }}
              </div>
            </div>
          </div>
        </div>
        <div class="ranking-list-box">
          <div class="myWrapper" v-if="myData">
            <RankingItem :currentJobTab="currentJobTab" isMe :list="[myData]" :currentGroupTab="currentGroupTab" />
          </div>
          <div class="ranking-list-item title">
            <div class="ranking-num">排名</div>
            <div class="ranking-name">{{ jobTabs.length > 1 ? jobTabs[currentJobTab - 1]?.title1 : jobTabs[0]?.title1 }}</div>
            <div class="ranking-order">{{ jobTabs.length > 1 ? jobTabs[currentJobTab - 1]?.title2 : jobTabs[0]?.title2 }}</div>
            <div class="ranking-bonus">{{ jobTabs.length > 1 ? jobTabs[currentJobTab - 1]?.title3 : jobTabs[0]?.title3 }}</div>
          </div>
          <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" :dataInfo="dataInfo" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import RankingItem from './rankingItem.vue'
  import { debounce } from 'lodash';
  import { ActionSheet, Toast } from 'vant'

  export default {
    name: 'marSmRankList',
    components: {
      RankingItem,
      [ActionSheet.name]: ActionSheet
    },
    computed: {
      groupNoRewardAmtList() {
        return function (currentGroupTab) {// 添加防御性检查
          if (!this.dataInfo || !this.dataInfo.groupNoRewardAmtObj) {
            return []
          }

          return this.dataInfo?.groupNoRewardAmtObj?.rewardAmtList || []
        }
      }
    },
    data() {
      return {
        showRule: false, // 是否显示规则弹窗
        jobTabs: [], // 职位分类标签列表
        currentJobTab: '1',
        currentJobTabIndex: 0,
        currentGroupTab: '第一组', // 当前选中的分组
        loading: false, // 是否正在加载
        currentMoldTab: '', // 当前选中第三层分组
        finished: false, // 是否加载完成
        list: [], // 排名列表数据
        page: 1, // 当前页码
        error: false, // 是否发生错误
        themeArr: [
          {
            "url": "https://staticwecom.beautyfarm.com.cn/",
            "bannerImg": "qyjl",
            "title1": "区域经理",
            "title2": "目标达成率 ",
            "title3": "奖品",
            "tabType": "1"
          },
          {
            "url": "https://staticwecom.beautyfarm.com.cn/",
            "bannerImg": "zr",
            "title1": "门店主任",
            "title2": "目标达成率",
            "title3": "奖品",
            "tabType": "2"
          },
          {
            "url": "https://staticwecom.beautyfarm.com.cn/",
            "bannerImg": "khjl",
            "title1": "客户经理",
            "title2": "非0消费人数 ",
            "title3": "奖励美美币",
            "tabType": "3"
          },
        ],
        dataInfo: {},  //后端整个详情
        myData: {},     //我的个人数据
        updateTime: '', // 数据更新时间
      }
    },
    mounted() {
      this.getjobTabs()
    },
    methods: {
      // 初始化数据，获取销售列表
      getDataList: debounce(async function () {
        if (this.finished) return
        Toast.loading({
          forbidClick: true,
          duration: 0
        });
        try {
          const params = {
            groupNo: this.currentGroupTab,
            page: this.page,
            type: this.currentJobTab,
            limit: 10
          }
          const { code, msg, data } = await request({
            url: '/ym/new-year/ranking/getRankingInfoPage',
            method: 'get',
            params
          })
          if (code !== 0) {
            throw new Error(msg)
          }
          Toast.clear();
          // 对应jobTabs中的dataInfo赋值
          this.dataInfo = data
          this.myData = data.empRankingInfo
          this.updateTime = data.updateTime
          // 对赌激励取cspPkList ，销售纳新取cspMmbList
          const list = data && data.rankingList
          if (this.page == 1) {
            this.list = list
          } else {
            this.list = this.list.concat(list)
          }
          this.page += 1
          this.loading = false;

          if (list.length < 10) {
            this.finished = true;
          }
        } catch (error) {
          this.loading = false;
          this.error = true;
          // this.$toast(error)
        }

      }, 500),
      onLoad() {
        this.getDataList()
      },
      // 切换职位分类标签
      onJobTab(value) {
        this.currentJobTab = value.tabType * 1;
        this.currentJobTabIndex = this.jobTabs.findIndex(item => item.tabType == this.currentJobTab)
        this.page = 1
        this.finished = false
        this.error = false;
        this.getGroupTab()
      },
      // 切换分组标签
      onGroupTab(v) {
        this.currentGroupTab = v;
        this.finished = false
        this.error = false;
        this.page = 1
        this.getDataList()
      },
      toRule() {
        this.$router.push({ path: '/marSmRankListRules', query: { currentJobTab: this.currentJobTab } })
      },
      // 获取职位分类标签
      async getjobTabs() {
        const { data } = await request({
          url: '/ranking/tab-info/getYmRankingTabInfoList',
          method: 'get',
        })
        let newArr = []
        // 重组数据，该处理应新建数据进去
        if (data && data.length > 0) {
          newArr = data.map((item, index) => {
            let themeArrIndex = this.themeArr.findIndex((themeItem) => themeItem.tabType == item.tabType)
            if (themeArrIndex == -1) {
              return { ...item, ...this.themeArr[0] }
            } else {
              return { ...item, ...this.themeArr[themeArrIndex] }
            }
          })
        } else {
          newArr = [this.themeArr[2]]
        }
        this.jobTabs = newArr
        this.currentJobTab = data && data.length > 0 ? data[0].tabType : '3'
        this.currentJobTabIndex = this.jobTabs.findIndex(item => item.tabType == this.currentJobTab)
        if (this.currentJobTab == '3') {
          this.getDataList()
        } else {
          await this.getGroupTab()
        }
      },
      // 获取分组标签
      async getGroupTab() {
        const { data } = await request({
          url: '/ym/new-year/ranking/getGroupNoTab',
          method: 'get',
          params: { type: this.currentJobTab }
        })
        // 分组组装数据
        let currentJobTabIndex = this.jobTabs.findIndex(item => item.tabType == this.currentJobTab)
        this.jobTabs[currentJobTabIndex].groupTabs = data && data.groupNoList && data.groupNoList.length > 0 ? data.groupNoList : []

        // this.jobTabs[this.currentJobTab].groupNo = data && data.groupNo ? data.groupNo : data && data.list[0] // 默认选中
        // this.groupTabs = data && data.list && data.list.length > 0 ? data.list : []
        this.currentGroupTab = data && data.groupNo ? data.groupNo : data && data.groupNoList[0] // 默认选中
        this.getDataList()
      }
    }
  }
</script>

<style lang='less' scoped>
  .ranking {
    position: relative;
    height: 100%;
    font-size: 28px;
    overflow-y: scroll;
    color: #333333;
    background-color: #fff;

    .flex-around {
      display: flex;
      justify-content: space-around;
    }

    .flex-between {
      display: flex;
      justify-content: space-between;
    }
  }


  .myWrapper {
    padding: 20px;
  }

  .banner {
    width: 100%;
    min-height: 464px;
    height: 464px;
  }

  .rule {
    position: absolute;
    width: 120px;
    top: 50px;
    right: 0;
    height: 61px;
    line-height: 61px;
    font-size: 26px;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.5);
    border-top-left-radius: 31px;
    border-bottom-left-radius: 31px;
    // padding: 10px 0;
  }

  .reward-box {
    position: relative;
    width: 100%;
    margin-top: -94px;
    padding: 30px;
    text-align: center;
    background-color: #fff;
    border-radius: 40px;
    z-index: 9;


    .bear-palm {
      width: 100%;
      background: #EEF8FF;
      border-radius: 50px;
      padding: 0 63px;
      font-size: 26px;
      color: #333333;
      padding-bottom: 45px;

      >p {
        width: 325px;
        height: 70px;
        background: #A3C8E2;
        border-radius: 0px 0px 40px 40px;
        margin: 0 auto;
        text-align: center;
        font-weight: bold;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 70px;
        text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
        margin-bottom: 36px;
      }

      img {
        width: 100%;
      }

      .reward-bot {
        margin-bottom: 20px !important;
        display: flex;
        color: #333;
        font-size: 26px;

        p {
          // width: calc(100% - 120px);
          text-align: left;
          margin: 0;
          padding: 0;
        }
      }

      .reward-content {
        margin-bottom: 20px !important;
        color: #333;
        font-size: 24px;
        text-align: left;

        span {
          color: #D41D16;
          font-size: 30px;
          font-weight: bold;

        }
      }

      .reward-tips {
        margin-top: 20px !important;
        color: #666666;
        font-size: 18px;
      }

      .prizeWrapper {
        margin-top: 40px;
        align-items: center;

        .prizeRank>div {
          margin-bottom: 10px;
          font-size: 30px;
          font-weight: bold;
          color: #D41D16;
        }

        .prizeRank>.prizeTitle {
          font-size: 26px;
          color: #333333;
        }

        img {
          width: 150px;
        }
      }

    }


  }


  .update-time {
    font-size: 24px;
    color: #999999;
    margin-top: 20px;
  }

  .ranking-box {
    overflow: hidden;
    background-color: #fff;
    border-radius: 40px 40px 0 0;
  }


  .tabs-box {
    padding: 0 30px;
  }

  .job-tabs {
    // display: flex;
    margin: 40px 0 10px 0;

    >div {
      display: flex;
      justify-content: space-around;
    }

    .group-tabs {
      display: flex;
      justify-content: flex-start;
      overflow-x: auto;
    }
  }

  .job-tab-item {
    color: #999999;
    font-size: 30px;
    margin: 10px 0px 40px 0;
    font-weight: 500;
    text-align: center;
    border-radius: 30PX;
    position: relative;

    &.on {
      color: #333333;

      &::before {
        position: absolute;
        content: '';
        left: 50%;
        bottom: -15px;
        width: 40px;
        height: 6px;
        transform: translate(-50%);
        background-color: #333333;
        border-radius: 4px;
      }
    }
  }



  .group-tab-item {
    min-width: 22%;
    // margin-right: 30px;
    text-align: center;
    font-size: 26px;
    color: #333333;
    background-color: #E6E6E6;
    border-radius: 20px;
    padding: 3px 10px;
    margin-right: 23px;

    &.on {
      color: #333333;
      background-color: #83A8C2;
    }
  }

  .ranking-list-box {
    border-top: 2px solid #eeeeee;
  }


  .ranking-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin: 10px 0;
    padding: 30px 40px;
    border-bottom: 2px solid #eeeeee;

    &.title {
      padding-bottom: 0;
      border: none;
      color: #999999;
    }
  }

  .ranking-num {
    width: 60px;
    margin-right: 40px;


    >img {
      width: 50px;
      height: 60px;
    }
  }

  .ranking-name {
    display: flex;
    align-items: center;
    width: 240px;

    >.img {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }

  }

  .ranking-order {
    width: 160px;
    text-align: center;
  }

  .ranking-bonus {
    width: 180px;
    text-align: center;
  }




  .bg-color {
    height: 90px;
    margin: -30px 0;
    background-color: #96BDD9;
  }


  .arrivedWrapper {
    display: flex;
    box-sizing: border-box;
    padding: 40px 78px;
    justify-content: space-between;

    .title {
      font-size: 24px;
      color: #333333;
    }

    .countWraper {
      >.content {
        font-size: 46px;
        color: #D62C18;
        font-weight: 500;

        span {
          font-size: 30px;
          font-weight: 500;
        }
      }

      >.content.isReach {
        color: #0072FF;
      }

      >.title {
        margin-bottom: 38px;
      }
    }

    .saleWrapper {
      >.content {
        font-size: 46px;
        color: #0072FF;
        font-weight: 500;
      }

      >.title {
        margin-bottom: 38px;
      }
    }
  }

  .mb-50 {
    margin-bottom: 50px;
  }
</style>
<style lang="less">
  .ranking {

    .van-popup {
      overflow-y: visible;
    }

    .van-image__error {
      background-color: #A1A1A1;
    }

    .van-list__finished-text,
    .van-list__loading,
    .van-list__error-text {
      margin-top: -2px;
      background-color: #fff;
    }
  }
</style>
